import axios from 'axios';

const state = () => ({
    tokens : [],
    columns : [
        {
            key : "name",
            label : "name",
            display : true
        },
        {
            key:"created_at",
            label: "created_at",
            display : true,
            type: "date",
            format: null
        },
        {
            key:"last_used_at",
            label: "last_used_at",
            display : true,
            type: "date",
            format: null
        }        
    ],
    loaded: false,
    isSaving: false,
    lastAdded: null
})

// actions
const actions = {
    async update({commit, state, rootState}, data) {
        commit("isSaving", true);
        await axios.put(rootState.settings.url + "/api/v1/apitokens/" + data.id, data).then(response => {
            commit("update", response.data.data);
        });
        commit("isSaving", false);
    },

    async store({commit, state, rootState}, data) {
        commit("isSaving", true);
        await axios.post(rootState.settings.url + "/api/v1/apitokens", data).then(response => {
            commit("store", response.data.data);          
        })
        commit("isSaving", false);        
    },

    async load({commit, state, rootState}) {
        await axios.get(rootState.settings.url + "/api/v1/apitokens", {
            params: {search : ''}
        }).then((response) => {
            commit("setTokens", response.data.data);
            commit("loaded", true);
        })
    },

    async delete({commit, state, rootState}, data) {
        if (data.data.url !== undefined && data.data.ids.length > 0) {
            for (var i = 0; i < data.data.ids.length; i++) {
                var url = data.data.url + "/" + data.data.ids[i];
                await axios.delete(url).then(response => {
                    commit("deleteToken", data.data.ids[i]);
                }).catch(error => {
                   console.log(error.response.data.message);
                });
            }
        }
    }
}

// mutations
const mutations = {
    clean(state) {
        state.tokens = [];
        state.loaded = false;
    },
    update(state, data) {
        var index = state.tokens.findIndex(item => item.id == data.id);
        if(index >= 0) {
            state.tokens[index] = data;
        }
    },
    store(state, data) {
        state.tokens.unshift(data);
        state.lastAdded = data;
    },
    loaded(state, status) {
        state.loaded = status;
    },
    setTokens(state, tokens) {
        state.tokens = tokens;
    },
    isSaving(state, status) {
        state.isSaving = status;
    },
    deleteToken(state, id) {
        var index = state.tokens.findIndex(item => item.id == id);
        if (index >= 0) {
            state.tokens.splice(index, 1);
        }
    },
    removeLastAdded(state) {
        state.lastAdded = null;
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
    }
}
